import React from "react";
import PropTypes from "prop-types";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import YouTube from 'react-youtube';
import IconPlus from "../Icons/IconPlus";

const ProgramBanner = ({ title, description, video, link, bgColor }) => {
    return (
        <Container fluid tag="section" className={`program-banner py-5 ${bgColor}`}>
            <Container>
                <Row>
                    <Col xs="12" tag="article" className="text-center pb-5">
                        <h1 className="title">{title}</h1>
                    </Col>
                    <Col lg="6" tag="article">
                        {description.map(paragraph => (
                            <p>{paragraph}</p>
                        ))}
                        <a href={`/contacto?program=${link}`} className="btn__cta mt-5">
                            <IconPlus width={66} height={66} />
                            <span>Solicitar información</span>
                        </a>
                    </Col>
                    <Col lg="6" tag="article" className="text-center pt-4 pt-lg-0">
                        <YouTube
                            videoId={video}
                            opts={{
                                width: '415',
                                height: '416',
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </Container>
    )
};

ProgramBanner.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.arrayOf(PropTypes.string).isRequired,
    video: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    bgColor: PropTypes.string.isRequired,
};

export default ProgramBanner;